import { formatarData } from "../../../utils/solicitacoes/formatters";
import Campo from "../Shared/Campo";
import DigitacaoAtivosResumo from "./DigitacaoAtivosResumo";

const TIPO_COMODATO_LABEL = { GDM: "GDM", VASILHAMES_EMBALAGENS: "Vasilhames/Embalagens" };

// Dados acumulados do processo — sempre visível, independentemente da etapa atual.
export default function DetalheSolicitacaoAtivos({ detalheProcesso }) {
    if (!detalheProcesso) return null;

    return (
        <div className="bg-card border border-border rounded-lg shadow-card p-4 md:p-6 flex flex-col gap-4">
            <div>
                <h2 className="font-display text-base font-semibold text-foreground mb-4">Informações Gerais</h2>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                    <Campo label="Filial" valor={detalheProcesso.filialNome} />
                    <Campo label="Código da Rota" valor={detalheProcesso.codigoRota} />
                    <Campo label="Supervisor" valor={detalheProcesso.supervisor} />
                    <Campo label="Data prevista para entrega" valor={formatarData(detalheProcesso.dataPrevistaEntrega)} />
                    <Campo label="Motivo" valor={detalheProcesso.motivo} />
                    <Campo label="Tipo de Comodato" valor={TIPO_COMODATO_LABEL[detalheProcesso.tipoComodato] || detalheProcesso.tipoComodato} />
                </div>
                {detalheProcesso.documentosObrigatoriosComodato?.length > 0 && (
                    <p className="mt-3 text-xs text-amber-800 bg-amber-50 border border-amber-300 rounded-lg px-3 py-2">
                        <i className="fa fa-paperclip mr-1" />
                        Comodato GDM — anexos obrigatórios para enviar: <strong>{detalheProcesso.documentosObrigatoriosComodato.join(", ")}</strong>.
                        Use exatamente essas descrições nos anexos.
                    </p>
                )}
            </div>

            <div>
                <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Cliente</h3>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                    <Campo label="Código" valor={detalheProcesso.clienteCodigo} />
                    <div className="col-span-2">
                    <Campo label="Razão Social" valor={detalheProcesso.clienteRazaoSocial} />
                    </div>
                    <Campo label="Nome Fantasia" valor={detalheProcesso.clienteFantasia} />
                    <Campo label="Cidade" valor={detalheProcesso.clienteCidade} />
                    <Campo label="Estado" valor={detalheProcesso.clienteEstado} />
                    <Campo label="Bairro" valor={detalheProcesso.clienteBairro} />
                </div>
            </div>

            {detalheProcesso.itens?.length > 0 && (
                <div>
                    <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Produtos</h3>
                    <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-border text-sm">
                            <thead>
                                <tr className="text-left text-xs text-muted-foreground uppercase">
                                    <th className="py-1.5 pr-3">Código</th>
                                    <th className="py-1.5 pr-3">Descrição</th>
                                    <th className="py-1.5 pr-3">Quantidade</th>
                                    <th className="py-1.5 pr-3">Nº do GET</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-border">
                                {detalheProcesso.itens.map((item, i) => (
                                    <tr key={i}>
                                        <td className="py-1.5 pr-3">{item.codigoProduto}</td>
                                        <td className="py-1.5 pr-3">{item.descricao}</td>
                                        <td className="py-1.5 pr-3">{item.quantidade}</td>
                                        <td className="py-1.5 pr-3">{item.numeroGet || "-"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            {detalheProcesso.justificativaAnalise && (
                <div>
                    <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Justificativa da Análise (Supervisor)</h3>
                    <p className="text-sm text-foreground whitespace-pre-wrap">{detalheProcesso.justificativaAnalise}</p>
                </div>
            )}

            <DigitacaoAtivosResumo detalheProcesso={detalheProcesso} />
        </div>
    );
}